import type { Event, Patient, RunRecord, Scenario } from '@orgsim/shared';

// The map window is streamed to the examinee, so it must only ever hold what the map shows.
// Built as an allow-list: a field added to the scenario later stays out until it is added here.
// Removed: patient summary, findings, triage, expectedCategory and instructorNote; the
// scenario's alert, injects, situation text and limitedResources; free-text notes.
// The result is still typed as RunRecord so the shared reducer runs on it unchanged, but the
// removed fields are missing at runtime; only map-rendering code may consume it.
function examineePatient(p: Patient): Patient {
  return { id: p.id, number: p.number, position: p.position } as Patient;
}

export function examineeEvent(event: Event): Event | null {
  if (event.type === 'NoteAdded') return null;
  if (event.type === 'PatientAdded') return { ...event, patient: examineePatient(event.patient) };
  return event;
}

export function examineeRecord(run: RunRecord): RunRecord {
  const s = run.scenario;
  const scenario = {
    id: s.id,
    name: s.name,
    mode: s.mode,
    situation: { location: s.situation.location, keyword: s.situation.keyword },
    patients: s.patients.map(examineePatient),
    units: s.units.map((u) => ({
      id: u.id,
      type: u.type,
      callsign: u.callsign,
      position: u.position,
      status: u.status,
      organisation: u.organisation,
    })),
    drawings: s.drawings,
  } as unknown as Scenario;
  return {
    id: run.id,
    scenarioId: run.scenarioId,
    scenario,
    startedAt: run.startedAt,
    finishedAt: run.finishedAt,
    events: run.events.flatMap((e) => examineeEvent(e) ?? []),
  };
}
